var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { resolveStrokeWidth, strokeContextForCanvas, getActiveDiagram } from '../theme';
import { autoLayoutNodesResponsive, createDiagramGroup, readCanvasSize, separateOverlappingNodes, } from '../helpers';
import { createStateNode, } from '../primitives';
import { collectObstacles } from '../router';
import { connectNodePairs } from '../connectors';
import { maybeApplyDiagramFlow } from '../flow';
/** Create state machine diagram */
export function createStateMachine(app, data, options) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var _e, _f, _g;
    if (options === void 0) { options = {}; }
    var group = createDiagramGroup(app, 'stateMachine', __assign(__assign({}, options), { data: data }), { name: 'stateMachine' });
    var nodeMap = new Map();
    var canvas = readCanvasSize(options);
    var strokeCtx = strokeContextForCanvas(canvas.width, canvas.height);
    var edgeWidth = resolveStrokeWidth(getActiveDiagram().stroke.edge, strokeCtx);
    var layoutNodes = data.states.map(function (s) { return ({ id: s.id, x: s.x, y: s.y }); });
    autoLayoutNodesResponsive(layoutNodes, canvas.width, canvas.height, 64, 64);
    var states = data.states.map(function (s, i) {
        var _a, _b, _c, _d, _e, _f;
        return (__assign(__assign({}, s), { x: (_c = (_a = s.x) !== null && _a !== void 0 ? _a : (_b = layoutNodes[i]) === null || _b === void 0 ? void 0 : _b.x) !== null && _c !== void 0 ? _c : 48 + (i % 4) * 110, y: (_f = (_d = s.y) !== null && _d !== void 0 ? _d : (_e = layoutNodes[i]) === null || _e === void 0 ? void 0 : _e.y) !== null && _f !== void 0 ? _f : 48 + Math.floor(i / 4) * 100 }));
    });
    try {
        for (var states_1 = __values(states), states_1_1 = states_1.next(); !states_1_1.done; states_1_1 = states_1.next()) {
            var s = states_1_1.value;
            var nodeGroup = createStateNode(app, s.label, (_e = s.type) !== null && _e !== void 0 ? _e : 'normal');
            nodeGroup.x = (_f = s.x) !== null && _f !== void 0 ? _f : 0;
            nodeGroup.y = (_g = s.y) !== null && _g !== void 0 ? _g : 0;
            if (typeof s.rotation === 'number')
                nodeGroup.rotation = s.rotation;
            nodeGroup.metadata = __assign(__assign({}, nodeGroup.metadata), { diagramId: s.id });
            nodeMap.set(s.id, nodeGroup);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (states_1_1 && !states_1_1.done && (_a = states_1.return)) _a.call(states_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    separateOverlappingNodes(__spreadArray([], __read(nodeMap.values()), false), {
        gap: 18,
        canvasW: canvas.width,
        canvasH: canvas.height,
    });
    var edgeLayer = app.group({ zIndex: -10, listening: false });
    edgeLayer.metadata.diagramEdgeLayer = true;
    var allNodes = __spreadArray([], __read(nodeMap.values()), false);
    var obstacles = collectObstacles(allNodes);
    var pairs = [];
    try {
        for (var _h = __values(data.transitions), _j = _h.next(); !_j.done; _j = _h.next()) {
            var t = _j.value;
            var from = nodeMap.get(t.from);
            var to = nodeMap.get(t.to);
            if (!from || !to)
                continue;
            pairs.push({
                from: from,
                to: to,
                options: {
                    label: t.label,
                    edgeId: "".concat(t.from, "->").concat(t.to),
                    fromId: t.from,
                    toId: t.to,
                },
            });
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var _k = __values(connectNodePairs(app, pairs, {
            parent: group,
            obstacleNodes: allNodes,
            obstacles: obstacles,
            stroke: getActiveDiagram().edge,
            glowColor: getActiveDiagram().edgeGlow,
            glow: false,
            strokeWidth: edgeWidth,
            cornerRadius: 10,
            style: 'smart',
        })), _l = _k.next(); !_l.done; _l = _k.next()) {
            var g = _l.value;
            edgeLayer.add(g);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
        }
        finally { if (e_3) throw e_3.error; }
    }
    group.add(edgeLayer);
    try {
        for (var _m = __values(nodeMap.values()), _o = _m.next(); !_o.done; _o = _m.next()) {
            var node = _o.value;
            group.add(node);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
        }
        finally { if (e_4) throw e_4.error; }
    }
    maybeApplyDiagramFlow(app, group, options);
    return group;
}
